// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/pill.js';

import { paths } from '../generated/pill';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('pill', Original, paths);
